import * as Yup from 'yup';

export const complainRequestSchema = Yup.object({
  userId: Yup.string().nullable(),
  dateOfRequest: Yup.string(),
  requestReason: Yup.string()
    .required('Please Enter Description')
    .test('not-only-whitespace', 'Name cannot be only whitespace', (value) => {
      return value && value.trim().length > 0;
    })
});
